import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { SwitchConfigurationComponent } from '../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { P0003605DetectionFinBidonModalComponent } from '../../../P0003605/Modal/p0003605-detection-fin-bidon-modal/p0003605-detection-fin-bidon-modal.component';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { P00076VanneInstallationTypeEnum } from '../../Enum/P00076VanneInstallationTypeEnum';

@Component({
  selector: 'app-p00076-installation-vannes',
  templateUrl: './p00076-installation-vannes.component.html',
  styleUrls: ['./p00076-installation-vannes.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    SwitchConfigurationComponent,
    TranslatePipe,
  ],
})
export class P00076InstallationVannesComponent implements OnInit {
  private modalController: ModalController = inject(ModalController);
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00076VanneInstallationTypeEnum =
    P00076VanneInstallationTypeEnum;
}
